const URL = process.env.NODE_ENV === "production" ? "https://ace-high.net/mobile" : "http://localhost:5004/mobile";

const HEADLESS_URL = process.env.NODE_ENV === "production" ? "https://ace-high.net" : "http://localhost:5004";

function truncateString(str, maxLength) {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + "...";
  }
  return str;
}

function ifEmpty(value, defaultValue = "") {
  //if value is null or undefined retrunt defaultValue
  if (value === null || value === undefined) {
    return defaultValue;
  }
  return value.toLocaleString();
}

const point1 = "AP";
const point2 = "HTP";
const point3 = "무료토너먼트";
const brand_code = "ACEH";

const metaTag = "Ace High Holdem";

export { URL, HEADLESS_URL, truncateString, point1, point2,point3, ifEmpty, brand_code, metaTag };
